<script>
import {Link, router} from "@inertiajs/vue3";
import Permissions from "@/mixins/shared/permissions";
import MenuService from "@/helpers/MenuService";
import SettingsMenu from '@/pages/layouts/partials/header-settings-menu.vue'

export default {
    components: {
        Link,SettingsMenu
    },
    mixins: [Permissions],
    data() {
        return {
            'mobileMenuOpen': false
        }
    },
    mounted() {
        $(document)
            .on('wwdev.toggleSidebar.header', () => {
                this.mobileMenuOpen = !this.mobileMenuOpen;
            })
            .on('wwdev.closeMobileMenu.header', () => {
                this.mobileMenuOpen = false;
            });
    },
    methods: {
        toggleSidebar() {
            $(document).trigger('wwdev.toggleSidebar');
        },
		stopImpersonating(event) {
			// event.stopPropagation();
			MenuService.clearCache();
		},
        logout() {
            $.ajax({
                url: route('logout'),
                method: "POST",
            }).always(() => {
                router.visit(route('login'))
            });
        }
    }
}
</script>

<template>
    <header class="topbar bg-white shadow-lg">
        <div class="py-2 bg-primary"></div>
        <div class="container-fluid">
            <nav class="navbar top-navbar navbar-expand-md navbar-light">
                <Link class="d-none d-lg-block navbar-brand" :href="route('dashboard')">
                    <img :src="$page.props.app_logo" :alt="$page.props.app_name"/>
                </Link>

                <button type="button" class="d-lg-none" @click="toggleSidebar">
                    <i class="bi" :class="mobileMenuOpen ? 'bi-x-lg' : 'bi-list'"></i>
                </button>

                <div class="ms-auto">
                    <ul class="navbar-nav flex-row flex-nowrap align-items-center my-lg-0">
                        <li class="nav-item dropdown me-2 me-lg-50">
                            <button type="button" class="d-inline-flex text-decoration-none align-items-center dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="pe-2">
									<i v-if=$page.props.is_impersonating class="bi bi-incognito"></i>
									{{ $page.props.auth.user.name }}&nbsp;
								</span>
                                <span class="btn btn-circle btn-tertiary">
                                    <i class="bi bi-chevron-down"></i>
                                </span>
                            </button>

                            <div class="dropdown-menu dropdown-menu-end">
                                <Link :href="route('profile.edit')" class="dropdown-item">
                                    <i class="bi bi-person"></i>
                                    Mijn account
                                </Link>
								<div class="dropdown-divider"></div>
								<template v-if=$page.props.is_impersonating>
									<a :href="route('impersonate.stop')" @click="this.stopImpersonating" class="dropdown-item">
										<i class="bi bi-incognito"></i>
										Uitloggen als {{ $page.props.auth.user.name }}
									</a>
								</template>
                                <button @click.prevent="logout" class="dropdown-item">
                                    <i class="bi bi-box-arrow-right"></i>
                                    Uitloggen
                                </button>
                            </div>
                        </li>
                        <li v-if="canAny(['view sent emails log', 'manage translations' ])" class="nav-item dropdown me-2">
                            <button type="button" class="btn btn-circle btn-tertiary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="Instellingen">
                                <i class="bi bi-gear"></i>
                            </button>

                            <div class="dropdown-menu dropdown-menu-end">
                                <SettingsMenu />
                            </div>
                        </li>
                        <li class="nav-item right-side-toggle">
                            <button @click.prevent="logout" class="btn btn-circle btn-tertiary" title="Uitloggen" aria-label="Uitloggen">
                                <i class="bi bi-box-arrow-right"></i>
                            </button>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </header>
</template>